// Popup window for Stripe Checkout.
//
// Stripe refuses to render inside an iframe, so the embedded plan buttons used
// to navigate the whole top-level tab away from the partner's page. Opening a
// popup instead keeps their page loaded underneath: the customer pays in the
// popup, the popup reports back (see the popup_return handling in AppContext)
// and closes, and the embed refreshes in place.
//
// Popup blockers only allow window.open during the user's click, and the
// checkout-session URL arrives from the API after that. So this opens a
// placeholder window synchronously in the click handler, and the caller points
// it at Stripe once the URL is known. Returns null when the browser refuses —
// callers then fall back to the full-page redirect, which always works.
export const openCheckoutPopup = () => {
  if (typeof window === 'undefined') return null;
  try {
    const w = 480;
    const h = Math.min(780, window.screen?.availHeight || 780);
    const left = Math.max(0, Math.round((window.screen?.availWidth || w) / 2 - w / 2));
    const top = Math.max(0, Math.round(((window.screen?.availHeight || h) - h) / 3));
    const win = window.open('', 'msgpdf-checkout', `popup=yes,width=${w},height=${h},left=${left},top=${top}`);
    if (win) {
      try {
        win.document.write(
          '<!doctype html><title>Checkout</title>' +
          '<body style="font-family:system-ui,sans-serif;display:flex;align-items:center;' +
          'justify-content:center;height:100vh;margin:0;color:#5c6b6d">' +
          'Opening secure Stripe checkout&hellip;</body>'
        );
      } catch (_) {}
    }
    return win;
  } catch (_) {
    return null;
  }
};
